import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// showBack: with no title, show just the back arrow (icon only).
export default function Page({ children, title, actions, showBack = false }) {
    const navigate = useNavigate()
    // Opened directly (pasted link / new tab): there is no previous page to go back to.
    const goBack = () => (window.history.state?.idx > 0 ? navigate(-1) : navigate('/'))
    return (
        <React.Fragment>
            <div className="row mb-3 align-items-center">
                <div className="col-12 col-md-3 col-lg-3">
                    {title !== '' && (
                        <Button
                            onClick={goBack}
                            startIcon={<ArrowBackIcon fontSize="large" sx={{ color: '#F0B41B' }} />}
                            sx={{
                                color: '#333C4E',
                                textTransform: 'capitalize',
                                fontSize: '18px'
                            }}
                        >
                            {title}
                        </Button>
                    )}
                    {title === '' && showBack && (
                        <IconButton aria-label="Back" onClick={goBack} sx={{ color: 'common.black' }}>
                            <ArrowBackIcon sx={{ stroke: 'currentColor', strokeWidth: 1.5 }} />
                        </IconButton>
                    )}
                </div>

                <div className="col-12 col-md-12 col-lg-9 text-end mb-4 mb-lg-0">
                    {actions}
                </div>
            </div>
            {children}
        </React.Fragment>
    )
}